import { Link } from 'react-router-dom'
import { Home } from 'lucide-react'

export function NotFoundPage() {
  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50">
      <div className="text-center">
        <h1 className="text-6xl font-bold text-gray-300 mb-4">404</h1>
        <h2 className="text-xl font-semibold text-gray-700 mb-2">
          Página no encontrada
        </h2>
        <p className="text-gray-500 mb-6">
          La página que buscas no existe o fue movida.
        </p>
        <Link to="/" className="btn btn-primary inline-flex items-center gap-1.5">
          <Home size={16} />
          Volver al inicio
        </Link>
      </div>
    </div>
  )
}
